// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2q_QV","tab":"ProcedureTabs_tab__2Y9LB"};